import React, {useEffect, useState} from 'react';
import {Box, Tooltip} from "@chakra-ui/react";
import {useStateContext} from "../contexts/ContextProvider";

export const Fragment = ({content, index, bookMark, setBookMark, currentChapter}) => {
    const {main} = useStateContext();
    const [isLabelOpen, setIsLabelOpen] = useState(false);
    const [id, setId] = useState(null);
    const second = main === "eng" ? "hun" : "eng";

    useEffect(() => {
        if (bookMark === index) {
            setBookMark(index);
            setId("bookmarked");
        } else {
            setId(null);
        }
    }, [bookMark, index]);

    const handleDoubleClick = () => {
        const isSameBookmark = String(bookMark) === String(index);

        if (isSameBookmark) {
            localStorage.removeItem("got1BookMarkIndex");
            localStorage.removeItem("got1BookMarkChapter");
            setBookMark(null);
            setId(null);
            return;
        }

        const previousBookmark = document.querySelector('#bookmarked');
        if (previousBookmark) {
            previousBookmark.removeAttribute('id');
            setBookMark(null)
        }
        localStorage.setItem("got1BookMarkIndex", index);
        localStorage.setItem("got1BookMarkChapter", String(currentChapter));
        setBookMark(index);
        setId("bookmarked");
    };

    return (
        <Tooltip
            maxW="60vw"
            label={
                <Box fontSize="xl" fontWeight="medium">{content[second] || content[`${second}Alt`]}</Box>
            }
            placement="top"
            aria-label={content[second] || content[`${second}Alt`]}
            isOpen={isLabelOpen}
        >
            <span
                className={`hover:bg-amber-200 ${id ? 'underline' : ''}`}
                // onMouseEnter={() => setIsLabelOpen(true)}
                onMouseLeave={() => setIsLabelOpen(false)}
                onClick={() => setIsLabelOpen(!isLabelOpen)}
                onDoubleClick={() => handleDoubleClick()}
                id={id}
            >
                {main === "hun" && content.break && (
                    <>
                        <br />
                        <span className="pr-8"></span>
                    </>
                )}
                <span className={main === "eng" ? content.engStyle : content.hunStyle}>{content[main] + " "}</span>
            </span>
        </Tooltip>
    );
};
